import React from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '_constants';
import { useUserActions } from 'state';
import { Button } from 'components/_shared/Button';
import { MenuItem, StyledMenu, MenuLink, MobileMenu, SettingMenu } from './Menu.styles';

export const Menu = ({ partner, customer, alertsCount, zones }) => {
  const { pathname } = useLocation();
  return (
    <>
      <StyledMenu>
        <MenuItem isActive={pathname === ROUTES.ROOT}>
          <MenuLink to={ROUTES.ROOT}>Dashboard</MenuLink>
        </MenuItem>
        {partner !== 'Corvus' && customer && (
          <MenuItem isActive={pathname.includes('upload')} to={ROUTES.UPLOAD}>
            <MenuLink to={ROUTES.UPLOAD}>Missions</MenuLink>
          </MenuItem>
        )}
        {customer === 'Dummen Orange' && (
          <MenuItem isActive={pathname.includes('alerts')} to={ROUTES.ALERTS}>
            <MenuLink to={ROUTES.ALERTS}>
              Alerts {alertsCount > 0 && <sup>{alertsCount}</sup>}
            </MenuLink>
          </MenuItem>
        )}
        {zones.length !== 0 && (
          <MenuItem isActive={pathname.includes('copilot')} to={ROUTES.COGROWER}>
            <MenuLink to={ROUTES.COGROWER}>CoGrower</MenuLink>
          </MenuItem>
        )}
      </StyledMenu>
      <MobileMenu toggleIcon='List'>
        <MenuLink to={ROUTES.ROOT} isActive={pathname === ROUTES.ROOT}>
          Dashboard
        </MenuLink>
        {partner !== 'Corvus' && customer && (
          <MenuLink isActive={pathname.includes('upload')} to={ROUTES.UPLOAD}>
            Missions
          </MenuLink>
        )}
        {customer === 'Dummen Orange' && (
          <MenuLink isActive={pathname.includes('alerts')} to={ROUTES.ALERTS}>
            Alerts <sup>{alertsCount}</sup>
          </MenuLink>
        )}
        {zones.length !== 0 && (
          <MenuLink to={ROUTES.GROWER} isActive={pathname === ROUTES.COGROWER}>
            CoGrower
          </MenuLink>
        )}
      </MobileMenu>
    </>
  );
};

export const ProfileMenu = ({ text }) => {
  const { toggleLogoutModal } = useUserActions();

  return (
    <SettingMenu toggleIcon='LogOut' toggleText={text} iconPosition='end'>
      <Button to={ROUTES.ACCOUNT} icon='Settings'>
        Profile
      </Button>
      <Button icon='LogOut' onClick={toggleLogoutModal}>
        Log Out
      </Button>
    </SettingMenu>
  );
};
